<template>
  <FlowManagePLTX />
</template>
  <script route="/hr/salary-flow/batch-adjustment">
  import FlowManagePLTX from '@/views/fin/salaryadministration/components/FlowManagePLTX.jsx'
  export default {
    components: {
      FlowManagePLTX
    }
  }
  </script>